export default "__VITE_ASSET__DfTYarhw__"